var render = function render(){var _vm=this,_c=_vm._self._c;return _c('article',{staticClass:"persona-mini card",on:{"click":function($event){return _vm.$emit('click', $event)}}},[_c('div',{staticClass:"persona-mini-icon",domProps:{"innerHTML":_vm._s(_vm.icon)}}),_c('h3',[_vm._v(_vm._s(_vm.title))]),_c('p',[_vm._v(_vm._s(_vm.tagline))])])
}
var staticRenderFns = []

export { render, staticRenderFns }